import React, { useState, useEffect } from "react";
import { Row, Col, Button, Modal, Spin } from "antd";
import EmailVerify from "@/Verification/EmailVerify";
import PhoneVerify from "@/Verification/PhoneVerify";
import ReadMore from "./ReadMore";
import PassWordVerify from "./PassWordVerify";
import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
function OtpPopUp({
    otpVisible,
    otpModal,
    otpParam,
    memberInfo,
    kindOfVerification,
    GetThroughoutVerification,
}) {
    // 初次彈窗顯示，控制彈窗，彈窗類別參數，會員信息
    const [readStep, setReadStep] = useState(0); // 0 選擇驗證框、1 了解更多框   4.密码修改
    const [bgHover, setBgHover] = useState(null); // hover 控制狀態
    const [phoneVisible, setPhoneVisible] = useState(false); // 彈手機驗證框
    const [emailVisible, setEmailVisible] = useState(false); // 彈email驗證框
    const [attemptRemaining, setAttemptRemaining] = useState(5); // 电话剩餘次數
    const [emailattemptRemaining, setEmailAttemptRemaining] = useState(5); // 邮箱剩餘次數
    const [loading, setloading] = useState(false); // 加载状态

    useEffect(() => {
        GetVerificationAttempt("Phone");
        GetVerificationAttempt("Email");
    }, []);

    const prams = {
        // 引用參數
        memberInfo: memberInfo && memberInfo,
        closeModal: () => setPhoneVisible(false),
        otpParam: otpParam,
        times: 5,
        attemptRemaining: attemptRemaining,
        setAttemptRemaining: setAttemptRemaining,
        kindOfVerification: kindOfVerification && kindOfVerification,
        emailattemptRemaining: emailattemptRemaining,
        setEmailAttemptRemaining: setEmailAttemptRemaining,
        GetThroughoutVerification: GetThroughoutVerification,
    };

    let verifyList;
    if (attemptRemaining <= 0 && emailattemptRemaining > 0) {
        verifyList = [
            {
                name: "Email",
                content: "通过邮箱验证",
                defaultImg: "/cn/img/user/otpVerify/e.svg",
            },
        ];
    } else if (emailattemptRemaining <= 0 && attemptRemaining > 0) {
        verifyList = [
            {
                name: "Phone",
                content: "通过手机验证",
                defaultImg: "/cn/img/user/otpVerify/p.svg",
            },
        ];
    } else if (emailattemptRemaining > 0 && attemptRemaining > 0) {
        verifyList = [
            {
                name: "Phone",
                content: "通过手机验证",
                defaultImg: "/cn/img/user/otpVerify/p.svg",
            },
            {
                name: "Email",
                content: "通过邮箱验证",
                defaultImg: "/cn/img/user/otpVerify/e.svg",
            },

            // {
            // 	name: 'CS',
            // 	content: '通过小同客服验证',
            // 	defaultImg: '/cn/img/user/otpVerify/cs.png'
            // }
        ];
    }

    const VerifyCategory = (param, otpVisible, status) => {
        param != "CS" && setReadStep(0); // 回到安全系統驗證
        param != "CS" && otpModal(otpVisible); // 關閉彈窗

        if (param == "Phone") return memberInfo && setPhoneVisible(status);
        if (param == "Email") return memberInfo && setEmailVisible(status);
        if (param == "CS" && kindOfVerification !== "revalidate")
            return PopUpLiveChat();
        if (param == "CS" && kindOfVerification === "revalidate") {
            PopUpLiveChat();
            global.globalExit();
        }
    };

    const GetVerificationAttempt = (verifyType) => {
        setloading(true);
        let channelType = verifyType == "Phone" ? "SMS" : "Email";
        //let serviceAction = this.state.type == 'loginOTP' ? 'OTP' : 'Revalidate';
        get(
            ApiPort.VerificationAttempt +
                `&channelType=${channelType}&serviceAction=${"OTP"}`
        )
            .then((data) => {
                setloading(false);
                if (data.isSuccess) {
                    const IS_OLD_BFF = data
                        && Object.prototype.hasOwnProperty.call(data, 'result')
                        && Object.prototype.hasOwnProperty.call(data.result||{}, 'attempt');
                    const val = IS_OLD_BFF ? data.result.attempt : data.result;
                    if (channelType === "SMS") {
                        setAttemptRemaining(val);
                    } else {
                        setEmailAttemptRemaining(val);
                    }

                    // if (data.result.attempt == 0) {
                    // 	this.setState({
                    // 		overTheLimitVisible: true
                    // 	});
                    // }
                }
            })
            .catch((err) => {
                setloading(false);
            });
    };

    return (
        <React.Fragment>
            <Modal
                title={readStep == 1 ? "安全公告" : "安全验证"}
                className={`${readStep === 0 ? "loginOTPModal" : ""} ${
                    readStep == 1 ? "SecurityAnnouncement" : ""
                } modal-pubilc  OTP-modal `}
                visible={!memberInfo.isVerifiedEmail ? false : otpVisible} //会有老会员没有邮箱的情况
                closable={readStep == 1 ? true : false}
                centered={true}
                width={readStep == 0 ? 400 : 500}
                footer={null}
                zIndex={1500}
                onCancel={() => {
                    setReadStep(0);
                }}
            >
                {loading && <Spin size="large" tip="加载中，请稍后..." />}
                {readStep == 0 && (
                    <React.Fragment>
                        <Row>
                            <Col span={24}>
                                {/* <h3 className="otp-modal-title">安全系统升级</h3> */}
                                <div className="otp-modal-description">
                                    为了更好的保护您的账户安全，提高账户安全等级，反劫持并降低交易风险，我们需要您进行账户信息验证。
                                    <Button
                                        className="otpBtn"
                                        onClick={() => {
                                            setReadStep(1);
                                            Pushgtagdata("Details_loginOTP");
                                        }}
                                        block
                                    >
                                        了解更多
                                    </Button>
                                </div>
                            </Col>

                            <div className="OtpList">
                                {memberInfo &&
                                    verifyList &&
                                    verifyList.map((item, index) => {
                                        // 可驗證管道
                                        if (
                                            !memberInfo.isVerifiedEmail &&
                                            item.name == "Email"
                                        )
                                            return;
                                        return (
                                            <div key={index} className="otpBox">
                                                <div
                                                    className={`verify-icon-wrap ${
                                                        item.name == bgHover
                                                            ? "red-" + item.name
                                                            : "default"
                                                    }`}
                                                    onClick={() => {
                                                        VerifyCategory(
                                                            item.name,
                                                            false,
                                                            true
                                                        );
                                                        Pushgtagdata(
                                                            "Verification",
                                                            "Click",
                                                            `${item.name}_LoginOTP`
                                                        );
                                                    }}
                                                    onMouseEnter={() =>
                                                        setBgHover(item.name)
                                                    }
                                                    onMouseLeave={() =>
                                                        setBgHover(null)
                                                    }
                                                >
                                                    <img
                                                        className="verify-icon"
                                                        src={item.defaultImg}
                                                        alt={item.name}
                                                    />
                                                </div>
                                                <Button
                                                    type="primary"
                                                    onClick={() => {
                                                        // GetVerificationAttempt(item.name);
                                                        VerifyCategory(
                                                            item.name,
                                                            false,
                                                            true
                                                        );
                                                        Pushgtagdata(
                                                            "Verification",
                                                            "Click",
                                                            `${item.name}_LoginOTP`
                                                        );
                                                    }}
                                                >
                                                    {item.content}
                                                </Button>
                                            </div>
                                        );
                                    })}
                            </div>
                            {!verifyList && (
                                <div className="OtpList">
                                    <div className="otpBox">
                                        <div
                                            className={`verify-icon-wrap ${
                                                "CS" == bgHover
                                                    ? "red-" + "CS"
                                                    : "default"
                                            }`}
                                            onClick={() => {
                                                VerifyCategory("CS");
                                                Pushgtagdata("CS_loginOTP");
                                            }}
                                            onMouseEnter={() =>
                                                setBgHover("CS")
                                            }
                                            onMouseLeave={() =>
                                                setBgHover(null)
                                            }
                                        >
                                            <img
                                                className="verify-icon"
                                                src="/cn/img/user/otpVerify/cs.svg"
                                                alt="CS"
                                            />
                                        </div>
                                        <Button
                                            type="primary"
                                            onClick={() => {
                                                VerifyCategory("CS");
                                                Pushgtagdata("CS_loginOTP");
                                            }}
                                        >
                                            联系在线客服
                                        </Button>
                                    </div>
                                </div>
                            )}
                            <br />
                            <Button
                                onClick={() => {
                                    global.globalExit();
                                }}
                                block
                                ghost
                            >
                                跳过验证
                            </Button>
                        </Row>
                    </React.Fragment>
                )}
                {/* 了解更多 */}
                {readStep == 1 && (
                    <ReadMore
                        VerifyCategory={VerifyCategory}
                        setReadStep={setReadStep}
                    />
                )}
            </Modal>

            <EmailVerify
                {...prams}
                visible={emailVisible}
                email={
                    memberInfo.isVerifiedEmail && memberInfo.isVerifiedEmail[0]
                }
                changeVerify={VerifyCategory}
                Description={
                    <div style={{ textAlign: "justify" }}>
                        {kindOfVerification === "OTP"
                            ? "为了确保您帐户的安全，请按照以下说明验证您的电子邮件。"
                            : //重置密码
                              "点击”发送”，您的邮箱将会收到验证码，请输入您收到的验证码以完成本次验证,验证码将在1小时内有效。"}
                    </div>
                }
                callCS={
                    <div className="otp-cs-tip">
                        如果您想更新电子邮箱，请联系我们的
                        <span
                            className="otp-cs"
                            onClick={() => {
                                global.PopUpLiveChat();
                                Pushgtagdata("CS_loginOTP");
                            }}
                        >
                            在线客服
                        </span>
                    </div>
                }
                setReadStep={setReadStep}
                kindOfVerifications={kindOfVerification}
            />

            <PhoneVerify
                {...prams}
                visible={phoneVisible}
                phone={
                    memberInfo.isVerifiedPhone && memberInfo.isVerifiedPhone[0]
                }
                changeVerify={VerifyCategory}
                Description={
                    <div>
                        {kindOfVerification === "OTP"
                            ? "为了确保您帐户的安全，请按照以下说明验证您的手机号码。"
                            : //重置密码
                              "点击”发送”，您的手机将会收到验证码，请输入您收到的验证码以完成本次验证。"}
                    </div>
                }
                callCS={
                    <div className="otp-cs-tip">
                        如果您想更新手机号码，请联系我们的
                        <span
                            className="otp-cs"
                            onClick={() => {
                                global.PopUpLiveChat();
                                Pushgtagdata("CS_loginOTP");
                            }}
                        >
                            在线客服
                        </span>
                    </div>
                }
                modalTitle={`手机验证`}
                setReadStep={setReadStep}
                kindOfVerifications={kindOfVerification}
            />
            {readStep == 4 && (
                <PassWordVerify
                    otpPwdVisible={readStep == 4} // 彈窗顯示
                    // otpPwdVisible={otpVisible} // 用来直接显示修改密码的弹窗测试用
                    setReadStep={setReadStep}
                    VerifyCategory={VerifyCategory}
                />
            )}
        </React.Fragment>
    );
}

export default OtpPopUp;
